export default class Address {
  city = '';
  area = '';
  zipCode = '';
  address = '';
  fullAddress = '';
  addressInput = ''; // 輸入的地址，受使用者影響

  get addressWithoutZipCode() {
    return `${this.city}${this.area}${this.address}`;
  }

  constructor({
    city = '',
    area = '',
    zipCode = '',
    address = '',
    fullAddress = '',
    addressInput = '',
  } = {}) {
    this.city = city;
    this.area = area;
    this.zipCode = zipCode;
    this.address = address;
    this.fullAddress = fullAddress;
    this.addressInput = addressInput;
  }

  clone() {
    return new Address({
      city: this.city,
      area: this.area,
      zipCode: this.zipCode,
      address: this.address,
      fullAddress: this.fullAddress,
      addressInput: this.addressInput,
    });
  }
}
